import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "activityFlashCard",
    title: "Activity Flash Card",
    icon: require("./content-icon.svg"),
    category: "training",
    Viewer,
    Editor,
    Preview: Viewer
}